<template>
  <div class="mealOrderDetails">
    <van-row style="background: #fff; padding: 10px">
      <van-col span="12">
        <span>{{ shoppingData.mealTypeName }}</span>
        <span style="color: #8e8c92; margin-left: 10px">
          共{{ shoppingData.selectList.length }}道菜
        </span>
      </van-col>
      <van-col span="12" align="right">
        <span>共计</span>
        <span style="margin-left: 10px; color: #1e98d7">
          ￥{{ totalAmount }}
        </span>
      </van-col>
    </van-row>
    <p style="color: #8e8c92; padding: 10px">配送地址</p>
    <van-row style="background: #fff; padding-top: 10px">
      <van-form label-width="60">
        <van-row align="center" style="padding: 0 10px">
          <van-col span="14">
            <van-field
              v-model="form.userName"
              name=""
              label="联系人"
              placeholder="联系人"
              :rules="[{ required: true, message: '请填写联系人' }]"
            />
          </van-col>
          <van-col span="10">
            <van-radio-group v-model="form.sex" direction="horizontal">
              <van-radio :name="1">先生</van-radio>
              <van-radio :name="0">女士</van-radio>
            </van-radio-group>
          </van-col>
        </van-row>
        <van-row align="center">
          <van-col
            span="24"
            style="padding: 0 10px; border-top: 1px solid #ccc"
          >
            <van-field
              v-model="form.contactPhone"
              type="number"
              name=""
              label="电话号码"
              placeholder="请输入电话号码"
              :rules="[{ required: true, message: '请输入电话号码' }]"
            />
          </van-col>
          <van-col
            span="24"
            style="padding: 0 10px; border-top: 1px solid #ccc"
          >
            <van-field
              class="address"
              v-model="form.orgAddress"
              name=""
              label="地址"
              placeholder="请输入地址"
              :rules="[{ required: true, message: '请输入地址' }]"
            />
          </van-col>
        </van-row>
      </van-form>
    </van-row>
    <div style="margin: 16px">
      <van-button
        @click="onSubmit"
        round
        block
        type="primary"
        native-type="submit"
        style="background: #1e98d7"
      >
        ￥{{ totalAmount }} 确认下单
      </van-button>
    </div>
  </div>
</template>
<script setup>
import { computed, reactive, toRefs } from "vue";
import { getStorage } from "@/utils/common";
import { submitOrder } from "@/api/orderingFood/orderingFood";
import moment from "moment";
const state = reactive({
  shoppingData: JSON.parse(getStorage("shoppingData")),
  totalAmount: 0,
  form: { sex: 1, orgAddress: "" },
});
const { shoppingData, totalAmount, form } = toRefs(state);
state.form.orgAddress = state.shoppingData.orgAddress;
state.totalAmount = computed(() => {
  let price = 0;
  state.shoppingData.selectList.forEach((value) => {
    price += value.price * value.quantity;
  });
  return price;
});
// 提交
const onSubmit = () => {
  let reserveDate = moment(new Date()).format("YYYY-MM-DD");
  if (state.shoppingData.orderType == 3) {
    reserveDate = state.shoppingData.reserveDate;
  }
  let contactUser = state.form.userName;
  if (contactUser) {
    contactUser = `${state.form.userName}${
      state.form.sex == 1 ? "先生" : "女士"
    }`;
  }
  const data = {
    bedsideOrderSubmitOrderDishParams: state.shoppingData.selectList,
    canteenId: state.shoppingData.canteenId,
    orderType: state.shoppingData.orderType,
    reserveMeal: state.shoppingData.mealType,
    reserveDate,
    contactUser,
    orgId: state.shoppingData.orgId,
  };
  submitOrder(Object.assign(state.form, data)).then((v) => {
    const { data } = v;
    window.location.href = data;
  });
  console.log(data);
};
</script>
<style lang="scss" scoped>
.mealOrderDetails {
  background: #f2f2f2;
  height: 100vh;
  .van-form {
    width: 100%;
    .van-cell-group {
      margin: 0;
    }
    .van-field {
      padding: 10px 0;
    }
  }
  .address {
    ::v-deep .van-field__value {
      border-bottom: 1px solid #999;
    }
  }
}
</style>
